const productList = document.querySelector('.products-list');

if (productList) {
  const dropdownInputs = productList.querySelectorAll('.products-list .dropdown__list-item input');
  const selectionRow = productList.querySelector('.products-list__selections-row');
  const productFilterSelection = productList.querySelector('.products-list__selections');
  const filterDropdowns = productList.querySelectorAll('.products-list .dropdown');

  const toggleSelection = (inputId, inputText, placeHolderText, isChecked) => {
    const existingDiv = selectionRow?.querySelector(`[data-product="${inputId}"]`);

    if (isChecked && selectionRow) {
      if (!existingDiv) {
        const selectionItem = document.createElement('div');
        selectionItem.className = 'products-list__selections-item';
        selectionItem.dataset.product = inputId;
        selectionItem.innerHTML = `
          <button aria-label="remove ${inputText}" class="products-list__selections-close : d-flex-cc">
            <i class="icon : icon-close"></i>
          </button>
          <span class="products-list__selections-placeholder">${placeHolderText}:</span>
          <span class="products-list__selections-text">${inputText}</span>
        `;
        selectionRow.appendChild(selectionItem);
      }
    } else if (existingDiv) {
      existingDiv.remove();
    }

    productFilterSelection?.classList.toggle('hide', selectionRow?.children.length === 0);
  };

  const checkDropdownStatus = () => {
    filterDropdowns.forEach((dropdown) => {
      const selectedInputs = dropdown.querySelectorAll('input:checked');
      dropdown.classList.toggle('has-active-items', selectedInputs.length > 0);
    });
  };

  const axiosGetProductList = async (pageNumber) => {
    const selectedTypes = productList.querySelectorAll('[data-dropdown="product_types"] input:checked');
    const selectedBrands = productList.querySelectorAll('[data-dropdown="product_brands"] input:checked');
    const selectedLevelElem = productList.querySelector('.products-list .level-indicator.is-active');

    const productListElem = productList.querySelector('.products-list__list');
    const noResultElem = productList.querySelector('.products-list__not-found');
    const productListFooter = productList.querySelector('.products-list__footer');

    const formDataInput = {
      action: 'getFilteredProductList',
      alcoholTypes: joinActiveItems(selectedTypes),
      alcoholBrands: joinActiveItems(selectedBrands),
      alcoholLevel: selectedLevelElem?.getAttribute('data-slug') || '',
      pageNumber,
      nonce: await getNonceForAction('getFilteredProductList'),
    };

    checkDropdownStatus();

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      productListElem.innerHTML = '';

      if (productListElem && data.data.html_list) {
        productListElem.innerHTML = data.data.html_list;
        noResultElem.classList.add('hide');
      }

      if (noResultElem && !data.data.html_list) {
        noResultElem.classList.remove('hide');
      }

      if (productListFooter && data.data.html_pagination) {
        productListFooter.innerHTML = data.data.html_pagination;
      }

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['alcoholTypes', 'alcoholBrands', 'alcoholLevel', 'pageNumber']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));

      productList.scrollIntoView();
    } catch (err) {
      console.error(err);
    }
  };

  dropdownInputs.forEach((input) => {
    input.addEventListener('change', (event) => {
      const parentDropdown = event.target.closest('.dropdown');
      const {
        id: inputId,
        dataset: { text: inputText },
      } = event.target;

      const placeHolderText = parentDropdown?.getAttribute('data-placeholder');
      toggleSelection(inputId, inputText, placeHolderText, event.target.checked);

      axiosGetProductList(1);
    });
  });

  attachEvent('.products-list__selections-close', 'click', (ev) => {
    const parent = ev.target.closest('.products-list__selections-item');
    const productId = parent.getAttribute('data-product');

    document.getElementById(productId).checked = false;
    parent.remove();

    productFilterSelection.classList.toggle('hide', selectionRow.children.length === 0);

    axiosGetProductList(1);
  });

  attachEvent('.products-list .level-indicator', 'click', (ev) => {
    const activeItem = productList.querySelector('.products-list .level-indicator.is-active');

    if (ev.target.classList.contains('is-active')) {
      ev.target.classList.remove('is-active');
    } else {
      activeItem?.classList.remove('is-active');
      ev.target.classList.add('is-active');
    }

    axiosGetProductList(1);
  });

  // Pagination
  attachEvent('.products-list .pagination .pagination__number', 'click', (ev) => {
    ev.preventDefault();
    axiosGetProductList(ev.target.dataset.page);
  });

  // Scroll to Section
  window.addEventListener('DOMContentLoaded', () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const urlAlcoholTypes = urlSearchParams.get('alcoholTypes');
    const urlAlcoholBrands = urlSearchParams.get('alcoholBrands');

    if (urlAlcoholTypes || urlAlcoholBrands) {
      productList.scrollIntoView();
    }
  });
}
